<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-form-group :label="name == null ? 'Foto Pendukung' : name  " >
            <!-- {{ fotoPendukung.index }}
            <br>
            {{ fotoPendukung.id }} -->
            <!-- {{ fotoPendukung.fotoBarangPendukung }} -->
            <b-row>
                <b-col >
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="fotoPendukung.activeFotoPendukungBase64 != null">
                                <img :src="fotoPendukung.activeFotoPendukungBase64" alt="Foto Pendukung">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview()">View</b-button>
                                </div>
                            </div>
                            
                            <div class="foto-content-wrapper" v-else-if="fotoPendukung.name != null && isEditJenis == true">
                                <img :src='$baseFilePath + fotoPendukung.name' alt="Foto Pendukung">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview()">View</b-button>
                                </div>
                            </div>

                            <h6 v-else class="text-blue">No Photo</h6>
                        </div>
                        <div class="foto-action-wrapper" >
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="fotoPendukung.fotoBarangPendukung" name="fotoBarangPendukung"
                                    :state="Boolean(fotoPendukung.fotoBarangPendukung)"
                                    :placeholder="fotoPendukung.fotoBarangPendukungPlaceholder"
                                    drop-placeholder="Drop file here..."
                                    accept=".jpg, .png, .jpeg"
                                    @input="browseFile()"
                                    >
                                </b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>
                            <div class="action-camera-wrapper cameraSmallWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFotoBarang()">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <div class="action-reset-wrapper" v-if="fotoPendukung.urlFotoBarangPendukung != null && fotoPendukung.activeFotoPendukungBase64 != $baseFilePath + fotoPendukung.urlFotoBarangPendukung">
                                <b-button variant="cancelBtn" @click="resetFoto()">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form-group>

        <div v-if="fotoPendukung.name != null">
            <div class="form-dynamic-deleteWrapper" >
                <b-button variant="dynamicDeleteBtn" name="deleteFotoPendukung" @click="$emit('remove', fotoPendukung.id ,fotoPendukung.name ,idSpesifikasi )" :disabled="length == minLength"><i class="fa fa-times"></i></b-button>
            </div>
        </div>
        <div v-else>
            <div class="form-dynamic-deleteWrapper">
                <b-button variant="dynamicDeleteBtn" name="deleteFotoPendukung" @click="$emit('remove', fotoPendukung.id ,fotoPendukung.index )" :disabled="length == minLength"><i class="fa fa-times"></i></b-button>
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    name: 'foto-pendukung-jenis-barang',
    props: {
        fotoPendukung: { type: Object, required: true },
        length: { type: Number, required: true },
        minLength: { type: Number, required: true },
        name: {type: String},
        isBpkb: {type: Boolean},
        index: {type: Number},
        idSpesifikasi: {type: Number},
        isEditJenis : { type : Boolean , default: false},
    },
    methods: {
        ambilFotoBarang(){
            this.$emit("showModalCam", this.idSpesifikasi ,this.fotoPendukung.index)
        },

        openModalPreview(){
            this.$emit("showModalPreview",this.idSpesifikasi, this.fotoPendukung.id,this.fotoPendukung.index ,this.fotoPendukung.name)
                
        },

        browseFile(){
            this.toBase64(this.fotoPendukung.fotoBarangPendukung).then(async base64 => {
                var newResult = await this.$helper.resizeImage(base64)
                this.fotoPendukung.fotoBarangPendukungBase64 = newResult
                this.fotoPendukung.activeFotoPendukungBase64 = newResult
                this.fotoPendukung.checkFotoBarangPendukung = true
                this.fotoPendukung.isChangeFoto = true
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
            })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        resetFoto(){
            this.fotoPendukung.activeFotoPendukungBase64 = this.$baseFilePath + this.fotoPendukung.urlFotoBarangPendukung
        },

    }
}
</script>
